import { Menu, MenuItem, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';

import * as Actions from '../actions/imstat';
import MessageDialog from '../components/MessageDialog';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchTrainingProgressDataParam,
} from '../scenario/ImstatScenarioFactory';
import Config from '../site.config.json';
import { Routes, Screens } from '../utils/Routes';

const ITEM_HEIGHT = 48;

const styles = (theme: Theme) =>
	createStyles({
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		menuButton: {
			height: '32px',
			width: '32px',
		},
		pointer: {
			cursor: 'pointer',
		},
		rowBlue: {
			'&:hover': {
				backgroundColor: '#CEDDFF !important',
			},
			backgroundColor: '#D9E5Ff !important',
		},
		rowGray: {
			'&:hover': {
				backgroundColor: '#E5E5E5 !important',
			},
			backgroundColor: '#EEEEEE !important',
		},
		rowOrange: {
			'&:hover': {
				backgroundColor: '#FFEFBC !important',
			},
			backgroundColor: '#FFF4D1 !important',
		},
		rowPink: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
	});

/**
 * eラーニングテーブルタイプ
 */
export enum ELearningTableTypes {
	ONGOING,
	RESULT,
}

interface IState {
	functionMenus?: JSX.Element;

	errorStudyOrderdialogContent: string;
	errorStudyOrderdialogReplaceContent: string[];
	selectColumnsMenuAnchorEl?: HTMLElement;
	openErrorStudyOrderMessageDialog: boolean;
	openErrorJukouMessageDialog: boolean;
	openErrorJukouStatusSinseiMessageDialog: boolean;
	openErrorUdemyMessageDialog: boolean;
	openErrorExpiredMessageDialog: boolean;
	openNoticeExpired: { term: string; target: string } | null;
}

/**
 * eラーニングテーブル表示
 */
class ImstatELearningTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			errorStudyOrderdialogContent: '',
			errorStudyOrderdialogReplaceContent: [],
			openErrorExpiredMessageDialog: false,
			openErrorJukouMessageDialog: false,
			openErrorJukouStatusSinseiMessageDialog: false,
			openErrorStudyOrderMessageDialog: false,
			openErrorUdemyMessageDialog: false,
			openNoticeExpired: null,
		};
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getSelectedColumns();

		return (
			<>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					getTrProps={this.setRowColor(classes)}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.state.selectColumnsMenuAnchorEl &&
					this.getSelectColumnsMenu()}
				{this.state.functionMenus}
				<MessageDialog
					open={this.state.openErrorJukouMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatELearningTable_0001')}
					contents={[{ content: 'LMCM_I_00634' }]}
					onClose={this.handleErrorMessageJukouDialogClose}
					onClickOk={this.handleErrorMessageJukouDialogClose}
				/>
				<MessageDialog
					open={this.state.openErrorJukouStatusSinseiMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatELearningTable_0002')}
					contents={[{ content: 'LMCM_E_00677' }]}
					onClose={
						this.handleErrorMessageJukouStatusSinseiDialogClose
					}
					onClickOk={
						this.handleErrorMessageJukouStatusSinseiDialogClose
					}
				/>
				<MessageDialog
					open={this.state.openErrorUdemyMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatELearningTable_0001')}
					contents={[{ content: 'LMCM_E_16211' }]}
					onClose={this.handleErrorMessageUdemyDialogClose}
					onClickOk={this.handleErrorMessageUdemyDialogClose}
				/>
				<MessageDialog
					open={this.state.openErrorExpiredMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatELearningTable_0003')}
					contents={[{ content: 'LMCM_E_00693' }]}
					onClose={this.handleErrorMessageExpiredDialogClose}
					onClickOk={this.handleErrorMessageExpiredDialogClose}
				/>
				<MessageDialog
					open={this.state.openErrorStudyOrderMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatELearningTable_0001')}
					contents={[
						{
							content: this.state.errorStudyOrderdialogContent,
							replacements: this.state
								.errorStudyOrderdialogReplaceContent,
						},
					]}
					onClose={this.handleErrorMessageStudyOrderDialogClose}
					onClickOk={this.handleErrorMessageStudyOrderDialogClose}
				/>
				{this.state.openNoticeExpired && (
					<Dialog open={true} onClose={this.handleCloseNoticeExpired}>
						<DialogTitle>
							{i18n.t('ImstatELearningTable_0004')}
						</DialogTitle>
						<DialogContent>
							<DialogContentText>
								{i18n.t('ImstatELearningTable_0005', {
									term: this.state.openNoticeExpired.term,
									// tslint:disable-next-line:object-literal-sort-keys
									target: this.state.openNoticeExpired.target,
								})}
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button
								onClick={this.handleCloseNoticeExpired}
								color="primary"
							>
								{i18n.t('ImstatELearningTable_0006')}
							</Button>
						</DialogActions>
					</Dialog>
				)}
			</>
		);
	}

	protected handleShowDetailDialog = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: rowData.careerID,
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: true,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageJukouDialogClose = () => {
		this.setState({ openErrorJukouMessageDialog: false });
	};

	/**
	 * Udemyの閉じるボタンエラーメッセージ
	 */
	protected handleErrorMessageUdemyDialogClose = () => {
		this.setState({ openErrorUdemyMessageDialog: false });
	};

	/**
	 * 受講ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageJukouDialogOpen = () => {
		this.setState({ openErrorJukouMessageDialog: true });
	};

	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageStudyOrderDialogClose = () => {
		this.setState({ openErrorStudyOrderMessageDialog: false });
	};

	/**
	 * 受講ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageStudyOrderDialogOpen = () => {
		this.setState({ openErrorStudyOrderMessageDialog: true });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageJukouStatusSinseiDialogClose = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: false });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageJukouStatusSinseiDialogOpen = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: true });
	};

	/**
	 * Udemyの開くエラーメッセージ
	 */
	protected handleErrorMessageUdemyiDialogOpen = () => {
		this.setState({ openErrorUdemyMessageDialog: true });
	};

	/**
	 * 受講ボタン期間外エラーメッセージクローズ
	 */
	protected handleErrorMessageExpiredDialogClose = () => {
		this.setState({ openErrorExpiredMessageDialog: false });
	};

	/**
	 * 受講ボタン期間外エラーメッセージオープン
	 */
	protected handleErrorMessageExpiredDialogOpen = () => {
		this.setState({ openErrorExpiredMessageDialog: true });
	};

	/**
	 * 受講ボタン処理
	 * @param e イベントオブジェクト
	 */
	protected handleTrainingClick = (
		careerID: string,
		classID: string,
		outOfPeriodFlg: boolean,
		uncompletedCareers: string,
		unrepresentedCareerCnt: string
	) => (e: React.MouseEvent<HTMLElement>) => {
		if (uncompletedCareers !== null && uncompletedCareers !== '') {
			this.handleErrorMessageStudyOrderDialogOpen();
			if (unrepresentedCareerCnt !== '0') {
				this.setState({ errorStudyOrderdialogContent: 'LMCM_E_15513' });
				this.setState({
					errorStudyOrderdialogReplaceContent: [
						uncompletedCareers,
						unrepresentedCareerCnt,
					],
				});
			} else {
				this.setState({ errorStudyOrderdialogContent: 'LMCM_E_15512' });
				this.setState({
					errorStudyOrderdialogReplaceContent: [uncompletedCareers],
				});
			}
		} else {
			let pathname = Routes.getPath(Screens.ELEARNING);
			pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
			pathname = pathname.replace(/\/:class_id$/, `/${classID}`);
			this.props.pushHistoryState(pathname, {
				caller: window.location.pathname,
				outOfPeriodFlg,
			});
		}
	};

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowDetail = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
		to = to.replace(/\/:career_id/, `/${rowData.careerID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowChangeApplication = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;

		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowCancelApplication = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { aplType, careerID, classID } = rowData;

		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:apl_type/, `/${aplType}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * アンケート回答画面表示
	 * @param e イベントオブジェクト
	 */
	protected showQuestionnaire = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;
		let pathname = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(pathname, {
			caller: window.location.pathname,
		});
	};

	/**
	 * 課題提出画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowExercise = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID, kadaiWithin } = rowData;

		if (kadaiWithin === 0) {
			// 提出期限内なし
			this.setState({
				functionMenus: undefined,
				openNoticeExpired: {
					target: i18n.t('ImstatELearningTable_0007'),
					term: i18n.t('ImstatELearningTable_0008'),
				},
			});
			return;
		}
		let to = Routes.getPath(Screens.PERSONAL_EXERCISE);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
	};

	/**
	 * 実績申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowActResultApplication = (
		rowData: Actions.IELearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:nittei_only_flg/, `/0`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowStCancel = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:curriculum_flg/, `/0`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * テスト履歴画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowHistory = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 進捗状況画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowTrainingProgress = (
		e: React.MouseEvent<HTMLElement>
	) => {
		const index = e.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const { token, userAttr } = this.props;
			const rowData: Actions.IELearning = this.props.data[index];
			const { careerID, classID } = rowData;
			this.props.fetchTrainingProgressData(token, {
				careerID,
				classID,
				userAttr,
			});
		}
	};

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowApplicationStatus = (
		e: React.MouseEvent<HTMLElement>
	) => {
		const index = e.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const rowData: Actions.IELearning = this.props.data[index];
			const { careerID, classID, aplType } = rowData;
			const careerDetailDialog: Actions.ICareerDetailDialog = {
				apllType: aplType,
				careerID,
				classID,
				curriculumFlg: '0',
				setApplicationStatusDialog: true,
				setOpenCareerDetailDialog: false,
				setOpenCurriculumDetailDialog: false,
			};
			this.props.setCareerDetailDialog(careerDetailDialog);
		}
	};

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowActResultReference = (
		rowData: Actions.IResultELearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const {
			careerID,
			classID,
			seq,
			imstatListStatusId,
			reasonCode,
		} = rowData;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:seq/, `/${seq}`);
		const state = {
			careerID,
			classID,
			imstatListStatusId,
			reasonCode,
			seq,
		};
		this.props.pushHistoryState(to, state);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 再申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowApply = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID } = rowData;
		const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
		const state = {
			caller: window.location.pathname,
			careerType: '0',
			targetCareerId: careerID,
		};
		this.props.pushHistoryState(to, state);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 修了証明書表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowComplCertificate = (
		rowData: Actions.IResultELearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID } = rowData;
		const { userAttr } = this.props;

		let url = Config.tsqPath + '/tsq/pkg/action/per/certificate.action?';
		url = url + 'userId=' + userAttr.userId;
		url = url + '&locale=' + userAttr.locale;
		url = url + '&lang=' + userAttr.lang;
		url = url + '&careerID=' + careerID;
		url = url + '&accessType=10';
		window.open(url, '_blank');
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 行カラー設定
	 */
	protected setRowColor = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			className = classes.rowPink;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			className = classes.rowOrange;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			className = classes.rowBlue;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			className = classes.rowGray;
		}

		return {
			className,
		};
	};

	/**
	 * 全列情報取得
	 */
	protected getAllColumns(): any[] {
		if (this.props.type === ELearningTableTypes.ONGOING) {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={this.props.classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Cell: (row: RowRenderProps) => {
						const [
							jukou,
							careerID,
							classID,
							enqueteDispFlg,
							status,
							taskReportOkFlg,
							outOfPeriodFlg,
							kadaiWithin,
							enqueteWithin,
						] = row.value;
						const {
							uncompletedCareers,
							unrepresentedCareerCnt,
							externalCourseType,
						} = row.original;

						let jukouButtonLabel: string = i18n.t(
							'ImstatELearningTable_0009'
						);
						let canTraining: boolean = false;
						let cannotTrainingClickCb: () => void = this
							.handleErrorMessageJukouDialogOpen;
						if (
							jukou.slice(0, 1) === '1' &&
							externalCourseType !== 1
						) {
							// jukouの先頭が1であればそのまま表示
							jukouButtonLabel = jukou.replace(/1,/, '');
							jukouButtonLabel = i18n.t(jukouButtonLabel, {
								ns: 'force',
							});
							if (
								outOfPeriodFlg &&
								kadaiWithin === 0 &&
								enqueteWithin === 0
							) {
								// アンケートも課題も期限切れ
								cannotTrainingClickCb = this
									.handleErrorMessageExpiredDialogOpen;
							} else {
								// 期限内
								canTraining = true;
							}
						} else if (externalCourseType === 1) {
							// Udemyの場合は受講不可
							cannotTrainingClickCb = this
								.handleErrorMessageUdemyiDialogOpen;
						} else if (status === '受講申請中') {
							// 受講申請中の場合は受講不可
							cannotTrainingClickCb = this
								.handleErrorMessageJukouStatusSinseiDialogOpen;
						} else if (
							status === '取消申請中' ||
							status === '実績申請中'
						) {
							// 取消申請中・実績申請中の場合は受講不可
							cannotTrainingClickCb = this
								.handleErrorMessageJukouDialogOpen;
						} else if (enqueteDispFlg || taskReportOkFlg) {
							// アンケート・課題があれば受講可
							jukouButtonLabel = i18n.t(
								'ImstatELearningTable_0010'
							);
							canTraining = true;
						} else {
							// 上記以外の場合、受講不可
							cannotTrainingClickCb = this
								.handleErrorMessageJukouDialogOpen;
						}

						if (canTraining) {
							return (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.handleTrainingClick(
										careerID,
										classID,
										outOfPeriodFlg,
										uncompletedCareers,
										unrepresentedCareerCnt
									)}
								>
									{jukouButtonLabel}
								</Button>
							);
						} else {
							return (
								<Button
									variant="contained"
									color="default"
									size="small"
									onClick={cannotTrainingClickCb}
								>
									{jukouButtonLabel}
								</Button>
							);
						}
					},

					Header: i18n.t('ImstatELearningTable_0011'),
					accessor: (d: Actions.IOnGoingELearning) => [
						d.jukou,
						d.careerID,
						d.classID,
						d.enqueteDispFlg,
						d.status,
						d.taskReportOkFlg,
						d.outOfPeriodFlg,
						d.kadaiWithin,
						d.enqueteWithin,
					],
					id: 'jukou',
					show: false,
					style: { textAlign: 'center' },
					width: 140,
				},
				{
					Header: i18n.t('ImstatELearningTable_0012'),
					accessor: 'compulsoryID',
					show: false,
					width: 80,
				},
				{
					Header: i18n.t('ImstatELearningTable_0013'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.handleShowDetailDialog(
									row.original
								)}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: i18n.t('ImstatELearningTable_0014'),
					accessor: 'careerTitle',
					show: false,
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classID === 'CL000000'
							? i18n.t(row.value, { ns: 'force' })
							: row.value,
					Header: i18n.t('ImstatELearningTable_0015'),
					accessor: 'classTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						const m = /^(\d+)([^\s\d]+)$/.exec(row.value);
						return m
							? m[1] + i18n.t(m[2], { ns: 'force' })
							: row.value;
					},
					Header: i18n.t('ImstatELearningTable_0016'),
					accessor: 'zanNissuu',
					show: false,
					width: 60,
				},
				{
					Cell: (row: RowRenderProps) => {
						const targetAplTypes: string[] = [
							'0',
							'1',
							'2',
							'3',
							'4',
						];
						const status = i18n.t(row.value, { ns: 'force' });
						if (
							targetAplTypes.indexOf(row.original.aplType) !== -1
						) {
							return (
								// Todo リンク実装
								<span
									className={this.props.classes.link}
									onClick={this.handleShowApplicationStatus}
									data-index={row.index}
								>
									{status}
								</span>
							);
						}
						return <div>{status}</div>;
					},
					Header: i18n.t('ImstatELearningTable_0017'),
					accessor: 'status',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (!row.value) {
							return;
						}
						const progressBar: number = row.value.slice(0, -1);
						if (row.original.createProgressLinkFlg) {
							return (
								<div
									style={{
										backgroundColor: '#dadada',
										borderRadius: '2px',
										cursor: 'pointer',
										height: 20,
										width: '100%',
									}}
									onClick={this.handleShowTrainingProgress}
									data-index={row.index}
								>
									<div
										style={{
											backgroundColor:
												progressBar > 66
													? '#85cc00'
													: progressBar > 33
													? '#ffbf00'
													: '#ff2e00',
											borderRadius: '2px',
											height: '100%',
											transition: 'all .2s ease-out',
											width: `${progressBar}%`,
										}}
									>
										<span>{row.value}</span>
									</div>
								</div>
							);
						} else {
							return i18n.t('ImstatELearningTable_0018');
						}
					},
					Header: i18n.t('ImstatELearningTable_0019'),
					accessor: 'progress',
					show: false,
					sortMethod: (a: string, b: string): number => {
						const aProgress = Number(a.slice(0, -1));
						const bProgress = Number(b.slice(0, -1));
						if (isNaN(aProgress)) {
							return 1;
						} else if (isNaN(bProgress)) {
							return -1;
						}

						return aProgress > bProgress ? 1 : -1;
					},
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.enqueteDispFlg) {
							return (
								<span
									className={this.props.classes.link}
									onClick={this.showQuestionnaire(
										row.original
									)}
								>
									{row.value}
								</span>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatELearningTable_0020'),
					accessor: 'enquete',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.taskReportOkFlg) {
							return (
								<span
									className={this.props.classes.link}
									onClick={this.handleShowExercise(
										row.original
									)}
								>
									{row.value}
								</span>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatELearningTable_0021'),
					accessor: 'kadai',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('ImstatELearningTable_0022'),
					accessor: 'jissiKikan',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('ImstatELearningTable_0023'),
					accessor: 'courseStartDate',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0024'),
					accessor: 'courseEndDate',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0025'),
					accessor: 'target',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0026'),
					accessor: 'organizer',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let credit = row.value;
						if (credit !== null) {
							credit = credit.substring(0, credit.length - 2);
							return i18n.t('ImstatELearningTable_0058', {
								credit,
							});
						} else {
							return '';
						}
					},
					Header: i18n.t('ImstatELearningTable_0027'),
					accessor: 'credit',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0028'),
					accessor: 'kikan',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0029'),
					accessor: 'cost',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('ImstatELearningTable_0030'),
					accessor: 'mousikomiKikan',
					show: false,
				},
			];
		} else {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={this.props.classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Cell: (row: RowRenderProps) => {
						const [
							jukou,
							careerID,
							classID,
							enqueteDispFlg,
							taskReportOkFlg,
							outOfPeriodFlg,
							kadaiWithin,
							enqueteWithin,
						] = row.value;
						const externalCourseType =
							row.original.externalCourseType;

						let jukouButtonLabel: string = '';

						if (jukou.slice(0, 1) === '1') {
							jukouButtonLabel = jukou.replace(/1,/, '');
							jukouButtonLabel = i18n.t(jukouButtonLabel, {
								ns: 'force',
							});
							if (
								outOfPeriodFlg &&
								kadaiWithin === 0 &&
								enqueteWithin === 0
							) {
								// アンケートも課題も期限切れ
								return (
									<Button
										variant="contained"
										color="default"
										size="small"
										onClick={
											this
												.handleErrorMessageExpiredDialogOpen
										}
									>
										{jukouButtonLabel}
									</Button>
								);
							}
						} else if (externalCourseType === 1) {
							jukouButtonLabel = i18n.t(
								'ImstatELearningTable_0032'
							);
							return (
								<>
									<Button
										variant="contained"
										color="default"
										size="small"
										onClick={
											this
												.handleErrorMessageUdemyiDialogOpen
										}
									>
										{jukouButtonLabel}
									</Button>
								</>
							);
						} else if (enqueteDispFlg || taskReportOkFlg) {
							jukouButtonLabel = i18n.t(
								'ImstatELearningTable_0031'
							);
						} else {
							jukouButtonLabel = i18n.t(
								'ImstatELearningTable_0032'
							);
							return (
								<Button
									variant="contained"
									color="default"
									size="small"
									onClick={
										this.handleErrorMessageJukouDialogOpen
									}
								>
									{jukouButtonLabel}
								</Button>
							);
						}
						return (
							<Button
								variant="contained"
								color="primary"
								size="small"
								component={makeLink(
									careerID,
									classID,
									outOfPeriodFlg
								)}
							>
								{jukouButtonLabel}
							</Button>
						);
					},
					Header: i18n.t('ImstatELearningTable_0033'),
					accessor: (d: Actions.IOnGoingELearning) => [
						d.jukou,
						d.careerID,
						d.classID,
						d.enqueteDispFlg,
						d.taskReportOkFlg,
						d.outOfPeriodFlg,
						d.kadaiWithin,
						d.enqueteWithin,
					],
					id: 'jukou',
					show: false,
					style: { textAlign: 'center' },
					width: 140,
				},
				{
					Header: i18n.t('ImstatELearningTable_0034'),
					accessor: 'compulsoryID',
					show: false,
					width: 80,
				},
				{
					Header: i18n.t('ImstatELearningTable_0035'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.handleShowDetailDialog(
									row.original
								)}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: i18n.t('ImstatELearningTable_0036'),
					accessor: 'careerTitle',
					show: false,
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classID === 'CL000000'
							? i18n.t(row.value, { ns: 'force' })
							: row.value,
					Header: i18n.t('ImstatELearningTable_0037'),
					accessor: 'classTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						const targetAplTypes: string[] = [
							'0',
							'1',
							'2',
							'3',
							'4',
						];
						const status = i18n.t(row.value, { ns: 'force' });
						if (
							targetAplTypes.indexOf(row.original.aplType) !== -1
						) {
							return (
								// Todo リンク実装
								<span
									className={this.props.classes.link}
									onClick={this.handleShowApplicationStatus}
									data-index={row.index}
								>
									{status}
								</span>
							);
						}
						return <div>{status}</div>;
					},
					Header: i18n.t('ImstatELearningTable_0038'),
					accessor: 'status',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.enqueteDispFlg) {
							return (
								<span
									className={this.props.classes.link}
									onClick={this.showQuestionnaire(
										row.original
									)}
								>
									{row.value}
								</span>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatELearningTable_0039'),
					accessor: 'enquete',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.taskReportOkFlg) {
							return (
								<span
									className={this.props.classes.link}
									onClick={this.handleShowExercise(
										row.original
									)}
								>
									{row.value}
								</span>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatELearningTable_0040'),
					accessor: 'kadai',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('ImstatELearningTable_0041'),
					accessor: 'jissiKikan',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('ImstatELearningTable_0042'),
					accessor: 'startDate',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0043'),
					accessor: 'endDate',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0044'),
					accessor: 'target',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0045'),
					accessor: 'organizer',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let credit = row.value;
						if (credit !== null) {
							credit = credit.substring(0, credit.length - 2);
							return i18n.t('ImstatELearningTable_0059', {
								credit,
							});
						} else {
							return '';
						}
					},
					Header: i18n.t('ImstatELearningTable_0046'),
					accessor: 'credit',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0047'),
					accessor: 'kikan',
					show: false,
				},
				{
					Header: i18n.t('ImstatELearningTable_0048'),
					accessor: 'cost',
					show: false,
				},
			];
		}
	}

	/**
	 * 行スタイル設定
	 * @param state
	 * @param rowInfo 行情報
	 * @param columns
	 */
	protected setRowStyle(state: any, rowInfo: RowInfo, columns: undefined) {
		if (rowInfo === undefined) {
			return {
				style: {
					height: 62,
				},
			};
		}
		let rowColor: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			rowColor = '#FFE1E4';
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			rowColor = '#FFF4D1';
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			rowColor = '#D9E5Ff';
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			rowColor = '#EEEEEE';
		}
		return {
			backgroundColor: rowColor,
		};
	}

	/**
	 * 行メニュー取得
	 * @param functionMenuAnchorEl アンカー要素
	 * @param rowData 行情報
	 */
	protected getFunctionMenus(
		functionMenuAnchorEl: HTMLElement,
		rowData: Actions.IOnGoingELearning | Actions.IResultELearning
	) {
		let rowOnGoing: Actions.IOnGoingELearning | null = null;
		let rowResult: Actions.IResultELearning | null = null;
		if (this.props.type === ELearningTableTypes.ONGOING) {
			rowOnGoing = rowData as Actions.IOnGoingELearning;
		} else {
			rowResult = rowData as Actions.IResultELearning;
		}

		return (
			<Menu
				anchorEl={functionMenuAnchorEl}
				open={true}
				onClose={this.handleCloseMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: 200,
					},
				}}
			>
				<MenuItem onClick={this.handleShowDetail(rowData)}>
					{i18n.t('ImstatELearningTable_0049')}
				</MenuItem>
				{rowOnGoing && rowOnGoing.appChangeOkFlg && (
					<MenuItem
						onClick={this.handleShowChangeApplication(rowData)}
					>
						{i18n.t('ImstatELearningTable_0050')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.appResultOkFlg && (
					<MenuItem
						onClick={this.handleShowActResultApplication(rowData)}
					>
						{i18n.t('ImstatELearningTable_0051')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.lecCancelOkFlg && (
					<MenuItem onClick={this.handleShowStCancel(rowData)}>
						{i18n.t('ImstatELearningTable_0052')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.appCancelOkFlg && (
					<MenuItem
						onClick={this.handleShowCancelApplication(rowOnGoing)}
					>
						{i18n.t('ImstatELearningTable_0053')}
					</MenuItem>
				)}
				{rowResult && rowResult.referenceOkFlg && (
					<MenuItem
						onClick={this.handleShowActResultReference(rowResult)}
					>
						{i18n.t('ImstatELearningTable_0054')}
					</MenuItem>
				)}
				{rowResult && rowResult.certificateDispFlg && (
					<MenuItem
						onClick={this.handleShowComplCertificate(rowResult)}
					>
						{i18n.t('ImstatELearningTable_0055')}
					</MenuItem>
				)}
				{rowResult && rowResult.retakeOkFlg && (
					<MenuItem onClick={this.handleShowApply(rowData)}>
						{i18n.t('ImstatELearningTable_0056')}
					</MenuItem>
				)}
				{((rowResult && rowResult.testFlg) ||
					(rowOnGoing && rowOnGoing.testFlg)) && (
					<MenuItem onClick={this.handleShowHistory(rowData)}>
						{i18n.t('ImstatELearningTable_0057')}
					</MenuItem>
				)}
			</Menu>
		);
	}

	/**
	 * 選択中列取得
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}

	/**
	 * 列選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];

		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			if (this.props.type === ELearningTableTypes.ONGOING) {
				const rowData: Actions.IOnGoingELearning = this.props.data[
					index
				];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			} else if (this.props.type === ELearningTableTypes.RESULT) {
				const rowData: Actions.IResultELearning = this.props.data[
					index
				];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			}
		}
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 列選択メニューハンドラ
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 列選択メニュークローズハンドラ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * チェックボックス変更ハンドラ
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		if (this.props.type === ELearningTableTypes.ONGOING) {
			this.props.setOnGoingSelectedColumns(newSelectedColumns);
		} else if (this.props.type === ELearningTableTypes.RESULT) {
			this.props.setResultSelectedColumns(newSelectedColumns);
		}
	};

	/**
	 * 期限切れ通知クローズハンドラ
	 */
	protected handleCloseNoticeExpired = () => {
		this.setState({ openNoticeExpired: null });
	};
}

const makeLink = (
	careerID: string,
	classID: string,
	outOfPeriodFlg: boolean
) => {
	const link: React.FC<any> = props => {
		let pathname = Routes.getPath(Screens.ELEARNING);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id$/, `/${classID}`);

		return (
			<Link
				to={{
					pathname,
					state: { caller: window.location.pathname, outOfPeriodFlg },
				}}
				{...props}
			/>
		);
	};
	return link;
};

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchTrainingProgressData: (
		token: string,
		arg: IFetchTrainingProgressDataParam
	) => {
		const s = ImstatScenarioFactory.createFetchTrainingProgressData(
			dispatch,
			token
		);
		s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setOnGoingSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setImstatOnGoingELearningSelectedColumns({
				selectedColumns,
			})
		),
	setResultSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setImstatResultELearningSelectedColumns({ selectedColumns })
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

export interface IImstatELearningTableProps {
	data: Actions.IOnGoingELearning[] | Actions.IResultELearning[];
	selectedColumns: number[];
	type: ELearningTableTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IImstatELearningTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatELearningTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ImstatELearningTable.tsx